import { default as angular } from "angular";
import {
  vsName as GridSettingsServiceName,
  GridSettingsService,
} from "./grids/settings/gridSettingsService";
import { vsName as RecordGridName, recordGridComponentOptions } from "./grids";
import {
  vsComponentName as RecordGridViewName,
  vsServiceName as RecordGridViewServiceName,
  RecordGridViewComponentOptions,
  RecordGridViewServiceProvider,
} from "./views/recordGridView";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "./server/serverUtility";
import {
  DoubleClickHandlerService,
  vsName as DoubleClickHandlerServiceName,
} from "./grids/cells/doubleClickHandlerService";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "./forms/formly/fieldConfigurationHelpers";
import {
  recordSelectAyncConfig,
  repeaterConfig,
  recordFileConfig,
} from "./forms/formly/types";
import {
  vsName as csvWriterName,
  CsvWriterProvider,
} from "./csv/csvWriterProvider";
import {
  vsName as ColumnDefinitionServiceName,
  ColumnDefinitionService,
} from "./grids/columns/columnDefinitionService";
import {
  RecordsUtilsService,
  vsName as RecordsUtilsServiceName,
} from "./utils";

import {
  vsServiceName as FormViewServiceName,
  FormViewServiceProvider,
  vsComponentName as FormViewComponentName,
  formViewComponentOptions,
} from "./forms/formView";
import {
  ColumnDefinitionSetServiceProvider,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "./grids/columns/columnDefinitionSetService";

export const moduleName = "records";

const module = angular.module(moduleName, [
  "ui.bootstrap.modal",
  "SlotTrak.UI",
  "formly",
]);

module
  .config(recordSelectAyncConfig)
  .config(repeaterConfig)
  .config(recordFileConfig)
  .provider(csvWriterName, CsvWriterProvider)
  .provider(FormViewServiceName, FormViewServiceProvider)
  .provider(RecordGridViewServiceName, RecordGridViewServiceProvider)
  .service(GridSettingsServiceName, GridSettingsService)
  .service(ServerUtilityName, ServerUtility)
  .service(DoubleClickHandlerServiceName, DoubleClickHandlerService)
  .service(FieldConfigurationHelperServiceName, FieldConfigurationHelperService)
  .service(ColumnDefinitionServiceName, ColumnDefinitionService)
  .provider(ColumnDefinitionSetServiceName, ColumnDefinitionSetServiceProvider)
  .service(RecordsUtilsServiceName, RecordsUtilsService)
  .component(RecordGridName, recordGridComponentOptions)
  .component(RecordGridViewName, RecordGridViewComponentOptions)
  .component(FormViewComponentName, formViewComponentOptions);
